export const GOOGLE_REVIEWS_LIST = 'GOOGLE_REVIEWS_LIST';
